import { useImageFallback } from '@/hooks/useImageFallback';

interface AvatarProps {
  src: string | null;
  firstName: string;
  lastName: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-12 h-12 text-base',
};

function getInitials(firstName: string, lastName: string): string {
  const first = firstName.charAt(0).toUpperCase();
  const last = lastName.charAt(0).toUpperCase();
  return `${first}${last}`;
}

export function Avatar({
  src,
  firstName,
  lastName,
  size = 'md',
  className = '',
}: AvatarProps) {
  const { hasError, onError } = useImageFallback(src);
  const initials = getInitials(firstName, lastName);
  const showImage = src && !hasError;

  return (
    <div
      className={`${sizeClasses[size]} rounded-full overflow-hidden flex items-center justify-center bg-stone-200 text-stone-600 font-medium ${className}`}
    >
      {showImage ? (
        <img
          src={src}
          alt={`${firstName} ${lastName}`}
          className="w-full h-full object-cover"
          onError={onError}
        />
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
}
